export default __webpack_public_path__ + "static/media/EM1830.34I-42147_-25330_0.bd24cff9.jpg";